module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-91.73bc38d.woff2";